<template>
  <TopNav
    :currentBoard="this.currentBoard"
    :nodes="this.flowNodes"
    :edges="this.flowEdges"
    @changeBoard="changeBoard"
    @togglechat="togglechat"
  />
  <div id="dashboard_page" class="flexLeftRow container">
    <div id="dashboard_flow" :style="{ width: leftWidth + 'px' }">
      <Workflow
        v-if="this.currentBoard == 'workflow'"
        :nodes="this.flowNodes"
        :edges="this.flowEdges"
        @updateFlowChart="updateFlowChart"
      />
      <Statistics v-else-if="this.currentBoard == 'statistics'" />
      <div v-else>
        {{ this.currentBoard }}
      </div>
    </div>
    <!-- <div id="resize_handle" @mousedown="startResize"></div> -->
    <!-- :style="{ width: `calc(100% - ${leftWidth + 10}px)` }" -->
    <div id="dashboard_chat" style="width: 440px" v-if="this.chatIsToggled">
      <ChatPage
        :width="leftWidth"
        :flowNodes="this.flowNodes"
        :flowEdges="this.flowEdges"
        :chatConfig="this.boardConfig"
        @updateFlowChart="updateFlowChart"
      />
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
// import SideNav from "../../../components/utilities/SideNav.vue";
import Workflow from "../pageViews/dashboard/Workflow.vue";
import Statistics from "../pageViews/dashboard/Statistics.vue";
import ChatPage from "../pageViews/dashboard/ChatPage.vue";
import TopNav from "../../../components/utilities/TopNav.vue";
import { useBoardStore } from "@/stores/boardStore.js";

export default {
  name: "Workboards",
  components: {
    // SideNav,
    Workflow,
    ChatPage,
    TopNav,
    Statistics,
  },
  props: {
    // boardConfig: {
    //   type: Object,
    //   required: true,
    //   default: () => ({
    //     action: "",
    //     detail: "",
    //     user_type: "",
    //     existing_tools: "",
    //   }),
    // },
  },
  methods: {
    updateFlowChart(newNodes, newEdges) {
      this.flowNodes = newNodes;
      this.flowEdges = newEdges;
    },
    changeBoard(board) {
      this.currentBoard = board;
      this.togglechat();
    },
    togglechat() {
      this.chatIsToggled = !this.chatIsToggled;

      if (!this.chatIsToggled) this.leftWidth = window.innerWidth - 51;
      else this.leftWidth = window.innerWidth - 440;
    },
    startResize(e) {
      e.preventDefault();

      this.startX = e.clientX;
      this.startWidth = this.leftWidth;

      document.addEventListener("mousemove", this.resize);
      document.addEventListener("mouseup", this.stopResize);
    },

    resize(e) {
      // Calculate new width with a minimum size limit
      const newWidth = Math.max(
        100,
        this.startWidth + (e.clientX - this.startX)
      );
      // Prevent expanding beyond container width minus minimum right panel width
      const containerWidth = document.querySelector(".container").offsetWidth;
      this.leftWidth = Math.min(newWidth, containerWidth - 110);
    },

    stopResize() {
      document.removeEventListener("mousemove", this.resize);
      document.removeEventListener("mouseup", this.stopResize);
    },
  },
  beforeUnmount() {
    // Clean up event listeners when component is unmounted
    document.removeEventListener("mousemove", this.resize);
    document.removeEventListener("mouseup", this.stopResize);
  },
  setup() {
    return {};
  },
  data() {
    let calc_vw = window.innerWidth;

    const boardStore = useBoardStore();
    console.log(boardStore.boardConfig);
    // console.log(this.$router.query.boardConfig);

    return {
      leftWidth: calc_vw - 51, // Initial width of left panel
      currentBoard: "workflow",
      chatIsToggled: true,
      startX: 0,
      startWidth: 0,
      boardConfig: boardStore.boardConfig
        ? boardStore.boardConfig
        : {
            action: "",
            detail: "",
            user_type: "",
            existing_tools: "",
          },
      // flowNodes: [
      //   {
      //     "id": "1",
      //     "type": "base_node",
      //     "position": { "x": 810, "y": 0 },
      //     "data": {
      //       "label": "First node",
      //       "text": "This is the start of something amazing",
      //     },
      //   },
      //   {
      //     "id": "2",
      //     type: "parent_node",
      //     "position": { "x": 500, "y": 200 },
      //     "data": {
      //       "label": "Parent node",
      //       "text": "",
      //     },
      //   },
      //   {
      //     "id": "2a",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 50 },
      //     "parentNode": "2",
      //     "data": {
      //       "label": "2a node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "2b",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 250 },
      //     "parentNode": "2",
      //     "data": {
      //       "label": "2b node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "2c",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 450 },
      //     "parentNode": "2",
      //     "data": {
      //       "label": "2c node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "3",
      //     type: "parent_node",
      //     "position": { "x": 800, "y": 200 },
      //     "data": {
      //       "label": "Parent node 2",
      //       "text": "",
      //     },
      //   },
      //   {
      //     "id": "3a",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 50 },
      //     "parentNode": "3",
      //     "data": {
      //       "label": "3a node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "3b",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 250 },
      //     "parentNode": "3",
      //     "data": {
      //       "label": "3b node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "3c",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 450 },
      //     "parentNode": "3",
      //     "data": {
      //       "label": "3c node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "3d",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 650 },
      //     "parentNode": "3",
      //     "data": {
      //       "label": "3d node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "4",
      //     type: "parent_node",
      //     "position": { "x": 1100, "y": 200 },
      //     "data": {
      //       "label": "Parent node 3",
      //       "text": "",
      //     },
      //   },
      //   {
      //     "id": "4a",
      //     "type": "base_node",
      //     "position": { "x": 10, "y": 50 },
      //     "parentNode": "4",
      //     "data": {
      //       "label": "4a node",
      //       "text": "Start designing your workflow by chatting",
      //     },
      //     expandParent: true,
      //   },
      //   {
      //     "id": "5",
      //     "type": "base_node",
      //     "position": { "x": 1210, "y": 500 },
      //     "data": {
      //       "label": "Outside node",
      //       "text": "This node is not a parent node",
      //     },
      //   },
      // ],
      // "flowEdges": [
      //   { "id": "e1->2a", "source": "1", "target": "2a" },
      //   { "id": "e1->3a", "source": "1", "target": "3a" },
      //   { "id": "e1->4a", "source": "1", "target": "4a" },
      //   { "id": "e2a->2b", "source": "2a", "target": "2b" },
      //   { "id": "e2b->2c", "source": "2b", "target": "2c" },
      //   { "id": "e3a->3b", "source": "3a", "target": "3b" },
      //   { "id": "e3b->3c", "source": "3b", "target": "3c" },
      //   { "id": "e3c->3d", "source": "3c", "target": "3d" },
      //   { "id": "e2c->3d", "source": "2c", "target": "3d" },
      //   { "id": "e4a->3b", "source": "4a", "target": "3b" },
      //   { "id": "e4a->5", "source": "4a", "target": "5" },
      // ],
      flowNodes: [
        {
          "id": "1",
          "type": "base_node",
          "position": { "x": 0, "y": 0 },
          "data": {
            "label": "First node",
            "text": "This is the start of something amazing",
          },
        },
        {
          "id": "1",
          "type": "base_node",
          "position": { "x": 200, "y": 0 },
          "data": {
            "label": "Node",
            "text": "Start chatting to design your workflow",
          },
        },
      ],
      flowEdges: [{ "id": "e1->2", "source": "1", "target": "2" }],
    };
  },
};
</script>

<style scoped>
#dashboard_page {
  height: calc(100vh - 51px);
  width: 100%;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /* position: absolute; */
}
#dashboard_flow {
  height: 100%;
  /* width: 50vw; */
  margin-left: 51px;
  border-right: thin solid lightgray;
  /* width: calc(100vw - 440px); */
  overflow: hidden;
}
#dashboard_chat {
  height: calc(100vh - 50px);
  /* border-right: thin solid lightgray; */
  /* width: 50vw; */
  background: #f9f4ff;
  /* margin-left: 51px; */
}
#resize_handle {
  width: 5px;
  height: 100%;
  background-color: red;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;
}
</style>
